import { IncentiveOffer } from 'modules/incentivesMarket/types';

const getOfferReference = (offer: IncentiveOffer | null): string => {
  if (!offer) return '';
  const typePrefix = offer.type === 'SELL' ? 'OFV' : 'OFC';
  const year = new Date(offer.createdAt).getFullYear();
  const idSuffix = offer._id.slice(-6).toUpperCase();
  return `#${typePrefix}-${year}-${idSuffix}`;
};

export default getOfferReference;
